module.exports = __webpack_public_path__ + "4f03bd8dec67211ade8abdab39dcbf4a.png";